import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import PageMeta from "@/components/feature/PageMeta";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <PageMeta
        title="页面未找到 404｜511 求证档案"
        description="这个页面不存在或已调整位置，请返回首页继续查看 511 爆料时间线与证据对照内容。"
        keywords="511求证档案,页面未找到"
        path="/"
      />
      <section className="flex w-full flex-col items-center justify-center px-4 py-24 text-center md:px-6 lg:px-10">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-700">
          <i className="ri-compass-3-line text-3xl"></i>
        </span>
        <p className="mt-6 font-heading text-5xl font-black text-background-300 md:text-7xl">
          404
        </p>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          这条路径不在档案里
        </h1>
        <p className="mt-2 text-sm text-foreground-500">
          请求的地址：<span className="text-foreground-700">{location.pathname}</span>
        </p>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          它可能已被合并到其他条目。回到首页继续查看时间线与证据对照内容。
        </p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-home-5-line text-base"></i>
            </span>
            返回首页
          </Link>
          <Link
            to="/timeline"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300"
          >
            查看时间线
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}